// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteLogoData, DeleteLogoResponses, GetDrugCatalogByIdUsageData, GetDrugCatalogByIdUsageResponses, GetEventFiltersData, GetEventFiltersResponses, GetHealthIntegrationsData, GetHealthIntegrationsResponses, GetHealthMigrationsData, GetHealthMigrationsErrors, GetHealthMigrationsResponses, GetHealthVersionData, GetHealthVersionResponses, GetLicenceStateData, GetLicenceStateResponses, GetPatientsActiveSubstanceTotalsData, GetPatientsActiveSubstanceTotalsErrors, GetPatientsActiveSubstanceTotalsResponses, GetPatientsCountData, GetPatientsCountResponses, GetPatientsCumulatedDoseData, GetPatientsCumulatedDoseErrors, GetPatientsCumulatedDoseResponses, GetPatientsTherapiesCurrentActionsCountData, GetPatientsTherapiesCurrentActionsCountResponses, GetPatientsTherapiesTherapyDateActionsCountData, GetPatientsTherapiesTherapyDateActionsCountResponses, GetProductionCountData, GetProductionCountResponses, GetPublicSettingsData, GetPublicSettingsResponses, GetReportsExportByIdDownloadData, GetReportsExportByIdDownloadErrors, GetReportsExportByIdDownloadResponses, GetReportsExportData, GetReportsExportResponses, GetScaleAlibisCsvData, GetScaleAlibisCsvResponses, GetScaleAlibisExcelData, GetScaleAlibisExcelResponses, GetScaleAlibisPdfData, GetScaleAlibisPdfResponses, GetStocksCountData, GetStocksCountResponses, PostHl7ByIdReprocessData, PostHl7ByIdReprocessErrors, PostHl7ByIdReprocessResponses, PostHl7Data, PostHl7Responses, PostPatientsCanAddTherapiesData, PostPatientsCanAddTherapiesErrors, PostPatientsCanAddTherapiesResponses, PostPatientsCanAddTherapyData, PostPatientsCanAddTherapyErrors, PostPatientsCanAddTherapyResponses, PostPickingListDistributeOrdersData, PostPickingListDistributeOrdersResponses, PostReportsExportAcknowledgeData, PostReportsExportAcknowledgeResponses, PostReportsExportData, PostReportsExportPreviewData, PostReportsExportPreviewResponses, PostReportsExportResponses, PostReportsPrintAuditData, PostReportsPrintAuditResponses, PostReportsPrintSelectionData, PostReportsPrintSelectionResponses, UploadLogoData, UploadLogoResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const postHl7 = <ThrowOnError extends boolean = false>(options?: Options<PostHl7Data, ThrowOnError>): RequestResult<PostHl7Responses, unknown, ThrowOnError> => (options?.client ?? client).post<PostHl7Responses, unknown, ThrowOnError>({
    url: '/hl7',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Retry a failed inbound HL7 message
 *
 * Runs a FAILED inbound message through its handler again and updates the same log entry.
 */
export const postHl7ByIdReprocess = <ThrowOnError extends boolean = false>(options: Options<PostHl7ByIdReprocessData, ThrowOnError>): RequestResult<PostHl7ByIdReprocessResponses, PostHl7ByIdReprocessErrors, ThrowOnError> => (options.client ?? client).post<PostHl7ByIdReprocessResponses, PostHl7ByIdReprocessErrors, ThrowOnError>({ url: '/hl7/{id}/reprocess', ...options });

/**
 * Application version
 *
 *
 * Reports the deployed Cypro version (e.g. v0.2.0) from the APP_VERSION environment
 * variable the deployment compose file injects; empty on development builds.
 *
 */
export const getHealthVersion = <ThrowOnError extends boolean = false>(options?: Options<GetHealthVersionData, ThrowOnError>): RequestResult<GetHealthVersionResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetHealthVersionResponses, unknown, ThrowOnError>({ url: '/health/version', ...options });

/**
 * Database migrations status
 *
 *
 * Reports whether the database is in sync with the migrations bundled with this build,
 * using the same rule as drizzle's migrator: `ok` means running `cyp migrations` now
 * would apply nothing.
 *
 * Deploy tooling polls this endpoint and only rolls out the remaining services once the
 * status is `ok`, so code never runs against a schema that is missing columns.
 *
 * `drifted` lists bundled migrations that were never recorded in the database
 * (regenerated, merged out of order, or applied manually). Drizzle will never re-apply
 * them, so they do not affect the status; investigate them if the schema looks out of
 * sync with the code.
 *
 */
export const getHealthMigrations = <ThrowOnError extends boolean = false>(options?: Options<GetHealthMigrationsData, ThrowOnError>): RequestResult<GetHealthMigrationsResponses, GetHealthMigrationsErrors, ThrowOnError> => (options?.client ?? client).get<GetHealthMigrationsResponses, GetHealthMigrationsErrors, ThrowOnError>({ url: '/health/migrations', ...options });

/**
 * External hospital systems this installation is integrated with
 *
 *
 * Reports the hospital systems integrated with this deployment, derived from
 * environment variables rather than database settings, so operators can decide per
 * installation by configuring the CYPRO_ env file. `hl7` is the base HL7 interface
 * (the consumer always listens on HL7_PORT); `amms` is the Asseco system running
 * over that interface.
 *
 */
export const getHealthIntegrations = <ThrowOnError extends boolean = false>(options?: Options<GetHealthIntegrationsData, ThrowOnError>): RequestResult<GetHealthIntegrationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetHealthIntegrationsResponses, unknown, ThrowOnError>({ url: '/health/integrations', ...options });

export const getPatientsCount = <ThrowOnError extends boolean = false>(options?: Options<GetPatientsCountData, ThrowOnError>): RequestResult<GetPatientsCountResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPatientsCountResponses, unknown, ThrowOnError>({ url: '/patients/count', ...options });

export const getPatientsTherapiesCurrentActionsCount = <ThrowOnError extends boolean = false>(options?: Options<GetPatientsTherapiesCurrentActionsCountData, ThrowOnError>): RequestResult<GetPatientsTherapiesCurrentActionsCountResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPatientsTherapiesCurrentActionsCountResponses, unknown, ThrowOnError>({ url: '/patients-therapies/current-actions-count', ...options });

export const getPatientsTherapiesTherapyDateActionsCount = <ThrowOnError extends boolean = false>(options?: Options<GetPatientsTherapiesTherapyDateActionsCountData, ThrowOnError>): RequestResult<GetPatientsTherapiesTherapyDateActionsCountResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPatientsTherapiesTherapyDateActionsCountResponses, unknown, ThrowOnError>({ url: '/patients-therapies/therapy-date-actions-count', ...options });

export const getProductionCount = <ThrowOnError extends boolean = false>(options?: Options<GetProductionCountData, ThrowOnError>): RequestResult<GetProductionCountResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetProductionCountResponses, unknown, ThrowOnError>({ url: '/production/count', ...options });

export const postPickingListDistributeOrders = <ThrowOnError extends boolean = false>(options?: Options<PostPickingListDistributeOrdersData, ThrowOnError>): RequestResult<PostPickingListDistributeOrdersResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostPickingListDistributeOrdersResponses, unknown, ThrowOnError>({
    url: '/picking-list/distribute-orders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getStocksCount = <ThrowOnError extends boolean = false>(options?: Options<GetStocksCountData, ThrowOnError>): RequestResult<GetStocksCountResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetStocksCountResponses, unknown, ThrowOnError>({ url: '/stocks/count', ...options });

/**
 * Count the prescriptions and protocols that use a drug
 *
 * A used drug keeps its dose unit, since doses are stored without a unit (CY-369).
 */
export const getDrugCatalogByIdUsage = <ThrowOnError extends boolean = false>(options: Options<GetDrugCatalogByIdUsageData, ThrowOnError>): RequestResult<GetDrugCatalogByIdUsageResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetDrugCatalogByIdUsageResponses, unknown, ThrowOnError>({ url: '/drug-catalog/{id}/usage', ...options });

/**
 * Delete the application logo
 */
export const deleteLogo = <ThrowOnError extends boolean = false>(options?: Options<DeleteLogoData, ThrowOnError>): RequestResult<DeleteLogoResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<DeleteLogoResponses, unknown, ThrowOnError>({ url: '/logo', ...options });

/**
 * Upload or replace the application logo
 */
export const uploadLogo = <ThrowOnError extends boolean = false>(options: Options<UploadLogoData, ThrowOnError>): RequestResult<UploadLogoResponses, unknown, ThrowOnError> => (options.client ?? client).post<UploadLogoResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/logo',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const getPublicSettings = <ThrowOnError extends boolean = false>(options?: Options<GetPublicSettingsData, ThrowOnError>): RequestResult<GetPublicSettingsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPublicSettingsResponses, unknown, ThrowOnError>({ url: '/public-settings', ...options });

export const getEventFilters = <ThrowOnError extends boolean = false>(options?: Options<GetEventFiltersData, ThrowOnError>): RequestResult<GetEventFiltersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetEventFiltersResponses, unknown, ThrowOnError>({ url: '/event-filters', ...options });

export const getScaleAlibisCsv = <ThrowOnError extends boolean = false>(options: Options<GetScaleAlibisCsvData, ThrowOnError>): RequestResult<GetScaleAlibisCsvResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetScaleAlibisCsvResponses, unknown, ThrowOnError>({ url: '/scale-alibis/csv', ...options });

export const getScaleAlibisExcel = <ThrowOnError extends boolean = false>(options: Options<GetScaleAlibisExcelData, ThrowOnError>): RequestResult<GetScaleAlibisExcelResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetScaleAlibisExcelResponses, unknown, ThrowOnError>({ url: '/scale-alibis/excel', ...options });

export const getScaleAlibisPdf = <ThrowOnError extends boolean = false>(options: Options<GetScaleAlibisPdfData, ThrowOnError>): RequestResult<GetScaleAlibisPdfResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetScaleAlibisPdfResponses, unknown, ThrowOnError>({ url: '/scale-alibis/pdf', ...options });

export const getReportsExport = <ThrowOnError extends boolean = false>(options?: Options<GetReportsExportData, ThrowOnError>): RequestResult<GetReportsExportResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetReportsExportResponses, unknown, ThrowOnError>({ url: '/reports-export', ...options });

export const postReportsExport = <ThrowOnError extends boolean = false>(options: Options<PostReportsExportData, ThrowOnError>): RequestResult<PostReportsExportResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostReportsExportResponses, unknown, ThrowOnError>({
    url: '/reports-export',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postReportsExportAcknowledge = <ThrowOnError extends boolean = false>(options: Options<PostReportsExportAcknowledgeData, ThrowOnError>): RequestResult<PostReportsExportAcknowledgeResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostReportsExportAcknowledgeResponses, unknown, ThrowOnError>({
    url: '/reports-export/acknowledge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postReportsExportPreview = <ThrowOnError extends boolean = false>(options: Options<PostReportsExportPreviewData, ThrowOnError>): RequestResult<PostReportsExportPreviewResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostReportsExportPreviewResponses, unknown, ThrowOnError>({
    url: '/reports-export/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getReportsExportByIdDownload = <ThrowOnError extends boolean = false>(options: Options<GetReportsExportByIdDownloadData, ThrowOnError>): RequestResult<GetReportsExportByIdDownloadResponses, GetReportsExportByIdDownloadErrors, ThrowOnError> => (options.client ?? client).get<GetReportsExportByIdDownloadResponses, GetReportsExportByIdDownloadErrors, ThrowOnError>({ url: '/reports-export/{id}/download', ...options });

export const postReportsPrintSelection = <ThrowOnError extends boolean = false>(options: Options<PostReportsPrintSelectionData, ThrowOnError>): RequestResult<PostReportsPrintSelectionResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostReportsPrintSelectionResponses, unknown, ThrowOnError>({
    url: '/reports-print/selection',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postReportsPrintAudit = <ThrowOnError extends boolean = false>(options: Options<PostReportsPrintAuditData, ThrowOnError>): RequestResult<PostReportsPrintAuditResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostReportsPrintAuditResponses, unknown, ThrowOnError>({
    url: '/reports-print/audit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getPatientsActiveSubstanceTotals = <ThrowOnError extends boolean = false>(options: Options<GetPatientsActiveSubstanceTotalsData, ThrowOnError>): RequestResult<GetPatientsActiveSubstanceTotalsResponses, GetPatientsActiveSubstanceTotalsErrors, ThrowOnError> => (options.client ?? client).get<GetPatientsActiveSubstanceTotalsResponses, GetPatientsActiveSubstanceTotalsErrors, ThrowOnError>({ url: '/patients/active-substance-totals', ...options });

export const postPatientsCanAddTherapy = <ThrowOnError extends boolean = false>(options?: Options<PostPatientsCanAddTherapyData, ThrowOnError>): RequestResult<PostPatientsCanAddTherapyResponses, PostPatientsCanAddTherapyErrors, ThrowOnError> => (options?.client ?? client).post<PostPatientsCanAddTherapyResponses, PostPatientsCanAddTherapyErrors, ThrowOnError>({
    url: '/patients/can-add-therapy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postPatientsCanAddTherapies = <ThrowOnError extends boolean = false>(options?: Options<PostPatientsCanAddTherapiesData, ThrowOnError>): RequestResult<PostPatientsCanAddTherapiesResponses, PostPatientsCanAddTherapiesErrors, ThrowOnError> => (options?.client ?? client).post<PostPatientsCanAddTherapiesResponses, PostPatientsCanAddTherapiesErrors, ThrowOnError>({
    url: '/patients/can-add-therapies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getPatientsCumulatedDose = <ThrowOnError extends boolean = false>(options: Options<GetPatientsCumulatedDoseData, ThrowOnError>): RequestResult<GetPatientsCumulatedDoseResponses, GetPatientsCumulatedDoseErrors, ThrowOnError> => (options.client ?? client).get<GetPatientsCumulatedDoseResponses, GetPatientsCumulatedDoseErrors, ThrowOnError>({ url: '/patients/cumulated-dose', ...options });

/**
 * Get licence status and decoded payload
 *
 * Returns the current licence state and decoded payload for identity binding.
 */
export const getLicenceState = <ThrowOnError extends boolean = false>(options?: Options<GetLicenceStateData, ThrowOnError>): RequestResult<GetLicenceStateResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetLicenceStateResponses, unknown, ThrowOnError>({ url: '/api/licence', ...options });
